import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";

import type {
  CurrentDesktopAccount,
  DashIntegrationEventMap,
  MessagePayload,
} from "@mirage/service-fss-native/types";

export type Service = {
  getCurrentAccount: () => Promise<CurrentDesktopAccount>;
  reloadView: () => Promise<boolean>;
  showDashWindow: () => Promise<void>;
  hideDashWindow: () => Promise<void>;
  launchPersistentWindow: () => Promise<void>;
  getAccessToken: () => Promise<string>;
  getShortcutValue: () => Promise<string>;
  getFeatureSessionId: () => Promise<string>;
  getViewName: () => Promise<string>;
  addDashEsvEventListener: (
    eventName: keyof DashIntegrationEventMap,
    callback: (
      args: DashIntegrationEventMap[keyof DashIntegrationEventMap],
    ) => void,
  ) => Promise<() => void>;
  sendMessageToRenderer: (message: MessagePayload) => Promise<void>;
};

export default function provideFSSNativeService(service: Service) {
  return services.provide(ServiceId.FSS_NATIVE, service, []);
}
